app.controller('LoginRegistrationController', ['$rootScope', '$scope', '$location', function ($rootScope, $scope, $location) {


    $scope.form_disabled = false;

    $scope.register_data = {
        username: "",
        password: "",
        customer_code: "",
        postcode: "",
        user_registration: true,
        type: "user",
        response_url: 'https://' + $location.host() + '/login?is_new_registration=1'
    }

    $scope.onUsernameChange = function () {
        $scope.register_data.username = $scope.register_data.username.toLowerCase().replace(/\s+/g, '');
    }

    $scope.registerUser = function (validateFormCallback) {

        $scope.form_disabled = true;
        $rootScope.service.account.registerUser($scope.register_data, function (success, data, messages) {

            if (success) {
                $rootScope.service.tracking.track_event("Login status", "Register");
                window.location = data.response_url;
            } else {
                $scope.form_disabled = false;
            }

            validateFormCallback(success, messages);
        });
    };
}]);
